import client from '@/api/client';
import { gql } from '@apollo/client';

const getPackages = (locale?: string) => client
  .query({
    query: gql`
      query($locale: String) {
        getPackages(locale: $locale) {
          data {
            id
            title
            alias
            amount
            package_type
            subscription_type
            description
            status
            dt_updated {
              date
            }
            dt_created {
              date
            }
            prices {
              eur {
                id
                package_id
                currency
                price
                country
                dt_created {
                  date
                }
                dt_updated {
                  date
                }
              }
              pln {
                id
                package_id
                currency
                price
                country
                dt_created {
                  date
                }
                dt_updated {
                  date
                }
              }
              ron {
                id
                package_id
                currency
                price
                country
                dt_created {
                  date
                }
                dt_updated {
                  date
                }
              }
            }
          }
        }
      }
    `,
    variables: {
      locale,
    },
  });

const getPromocodes = (promocode: string) => client
  .query({
    query: gql`
      query($promocode: String) {
        getPromocodes(promocode: $promocode) {
          data {
            id
            promo_code
            amount
            type
            status
            title
            description
            payment_type
            user_id
            packages
            dt_created {
              date
            }
            start_date {
              date
            }
            finish_date {
              date
            }
            activations
          }
        }
      }
    `,
    variables: {
      promocode,
    },
  });

const makePayment = (priceId: number, promocode?: string) => client
  .query({
    query: gql`
      mutation (
        $price_id: Int
        $promo_code: String
      ) {
        makePayment(
          price_id: $price_id
          promo_code: $promo_code
        ) {
          id
          user_id
          price_id
          currency
          country
          status
          price
          amount
          description
        }
      }
    `,
    variables: {
      price_id: priceId,
      promo_code: promocode,
    },
  });

const continuePayment = (paymentId: number) => client
  .mutate({
    mutation: gql`
      mutation ($id: Int) {
        continuePayment(id: $id) {
          orderUrl
        }
      }
    `,
    variables: {
      id: paymentId,
    },
  });

export default {
  getPackages,
  getPromocodes,
  makePayment,
  continuePayment,
};
